import React from 'react';
import {
  AccordionTrigger,
} from "../components-shadcn/accordion";
import { isMobile } from 'react-device-detect';
import { useStore } from '../lib/store';

interface Props {
  openItem: string;
  number: number;
  title: string;
  value: string;
}

const CustomAccordionTrigger: React.FC<Props> = ({ openItem, number, title, value }) => {

  const { stage_seed } = useStore();
  
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (number > stage_seed) {
      e.preventDefault();
      e.stopPropagation();
    }
  }


  return (
    <AccordionTrigger onClick={handleClick} className={`flex flex-row items-center ${!isMobile && 'mt-[1rem]'}`}>
      <div className='flex flex-row items-center'>
        <div
          className={`w-[2.2rem] h-[2.2rem] rounded-[50%] flex items-center justify-center ${value === openItem || Number(value) <= stage_seed   ? 'bg-green-light border-green-dark' : ' bg-gray-light border-gray-primary'} border border-solid `}>
          <p className={`text-[0.9] ${value === openItem || Number(value) <= stage_seed  ? 'text-green-dark' : 'text-gray-dark'}`}>{number - 1}</p>
        </div>
        <p className={`text-[0.9] ml-[1rem] ${value === openItem || Number(value) <= stage_seed  ? 'text-green-dark font-[700]' : 'text-gray-dark'}`}>
          {title}
        </p>  
      </div>
    </AccordionTrigger>
  );
}

export default CustomAccordionTrigger;
